import { useEffect, useState } from 'react';
import { fetchCompradores } from '../../services/compradorService';
import { IComprador } from '../../interfaces/comprador.interface';


const useFetchCompradores = () => {
  const [compradores, setCompradores] = useState<IComprador[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const getCompradores = async () => {
      try {
        const data = await fetchCompradores();
        setCompradores(data);
      } catch (err) {
        setError('Falha ao buscar compradores');
      } finally {
        setLoading(false);
      }
    };

    getCompradores();
  }, []);

  return { compradores, loading, error };
};

export default useFetchCompradores;
